<router-outlet></router-outlet>
<ellf-loader
  [show]="isLoaderVisible$ | ngrxPush"
  [text]="loaderText$ | ngrxPush"
></ellf-loader>
